const currentYear = new Date()
  .getFullYear()

export const getFourYearsForward = (size = 4, startAt = currentYear) => {
  return [...new Array(size)
    .keys()].map(i => i + startAt)
}
